import { supabase } from '@/lib/supabase';

export interface WebhookTaskPayload {
  event: 'change_step';
  action: 'moved_to_todo' | 'moved_to_backlog' | 'priority_changed';
  task: {
    id: string;
    title: string;
    description: string | null;
    type: string;
    priority: string;
    board_status: string;
    client_priority: number | null;
    estimate_hours: number;
    estimate_days: number;
    value: number;
    paid: boolean;
    sprint_desired: boolean;
    sprint_id: string | null;
    observations: string | null;
    created_at: string;
  };
  project: {
    id: string;
    name: string;
    status: string;
    client_id: string | null;
  };
  client: {
    id: string | null;
    name: string | null;
    email: string | null;
  };
  triggered_by: {
    user_id: string;
    user_name: string | null;
    role: string | null;
  };
  timestamp: string;
}

export async function triggerChangeStepWebhook(payload: WebhookTaskPayload): Promise<void> {
  try {
    const { data: webhooks } = await supabase
      .from('webhook_configs')
      .select('webhook_url')
      .eq('event_name', 'change_step')
      .eq('is_active', true);

    if (!webhooks || webhooks.length === 0) return;

    await Promise.allSettled(
      webhooks.map(wh =>
        fetch(wh.webhook_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        }).catch(err => console.warn('[Webhook] Falha ao enviar:', wh.webhook_url, err))
      )
    );
  } catch (err) {
    console.warn('[Webhook] Erro ao buscar configurações:', err);
  }
}
